const SvgData2 = (props) => (
  <>
    <path
      d="M48 0C21.49 0 0 21.49 0 48s21.49 48 48 48 48-21.49 48-48S74.51 0 48 0Zm0 60c-6.63 0-12-5.37-12-12s5.37-12 12-12 12 5.37 12 12-5.37 12-12 12Z"
      fill={props.p40}
    />
  </>
);

export default SvgData2;
